import {Component, forwardRef, Injector, Input} from '@angular/core';
import {AbstractInput} from '../abstract-input';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {utc} from 'moment';

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DateInputComponent)
        }
    ],

    selector: 'vui-date-input',
    templateUrl: './date-input.component.html',
    styleUrls: ['./date-input.component.scss']
})
export class DateInputComponent extends AbstractInput {
    public _max: string;
    public _min: string;

    constructor(protected injector: Injector) {
        super(injector);
    }

    public get date(): string {
        if (utc(this.value).toISOString()) {
            return utc(this.value).toISOString().substring(0, 10);
        } else {
            return null;
        }
    }

    public set date(date: string) {
        this.value = date ? utc(date).toDate() : null;
    }

    public get max(): Date {
        return this._max ? utc(this._max).toDate() : null;
    }

    @Input()
    public set max(max: Date) {
        this._max = max ? utc(max).toISOString().substring(0, 10) : null;
    }

    public get min(): Date {
        return this._min ? utc(this._min).toDate() : null;
    }

    @Input()
    public set min(min: Date) {
        this._min = min ? utc(min).toISOString().substring(0, 10) : null;
    }
}
